/*
* Created by Rishabh Kumar on 21/06/19
* */

export * from "./generalTemplate";